import { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";
import Sidebar from "./Sidebar";
import Topbar from "./Topbar";
import ChatFloatingWidget from "../chat/ChatFloatingWidget";
import "./Dashboard.css";
import "./dashboard-theme.css";

interface Props {
  children: React.ReactNode;
}

export default function DashboardLayout({ children }: Props) {
  const { pathname } = useLocation();
  const hideChatWidget = pathname === "/dashboard/manager/chat";
  const [sidebarOpen, setSidebarOpen] = useState(false);

  useEffect(() => { setSidebarOpen(false); }, [pathname]);

  return (
    <div className="dashboard-wrapper">
      {sidebarOpen && (
        <div className="sidebar-overlay" onClick={() => setSidebarOpen(false)} />
      )}

      <Sidebar drawerOpen={sidebarOpen} onClose={() => setSidebarOpen(false)} />

      <div className="dashboard-content">
        <div className="dashboard-topbar-wrapper">
          <Topbar onOpenSidebar={() => setSidebarOpen(true)} />
        </div>

        <main className="dashboard-main">
          {children}
        </main>
      </div>

      {!hideChatWidget && <ChatFloatingWidget />}
    </div>
  );
}
